import React from "react";
import { FavoriteListNameInput } from "./FavoriteListNameInput";
import { FavoritesAlert } from "./FavoritesAlert";

interface CreateNewListProps {
	error?: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onCreateAlert: () => void;
}

export function CreateNewList({
	error,
	onChange,
	onCreateAlert,
}: CreateNewListProps) {
	return (
		<>
			<p>You have not saved any favourite lists yet.</p>
			<div className="modal__body">
				<section className="modal__section">
					<FavoriteListNameInput error={error} onChange={onChange} />
				</section>

				<FavoritesAlert onCreateAlert={onCreateAlert} />
			</div>
		</>
	);
}
